import customSelect from 'custom-select';

export default {
  init() {
    window.resourcePage = 0;
    window.init = true;
    window.postPerPage = 12;
    window.cstSel;
    this.handleForm();
    this.navigationHandler();
    this.styleSelect();
    this.getEnResourcesTranslation();
    this.loadFirstResourcesFromAPI();
    this.loadResourcesFromAPI();
    this.typeParamHandler();
    this.productParamHandler();
  },
  typeParamHandler() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has('type')) {
      let typeParam = urlParams.get('type');
      if (typeParam == 'webinar') {
        typeParam = 'webcast';
      }
      $('#input-type').val(typeParam);
      if ( $(window).outerWidth() > 992 ) {
        window.cstSel[2].value = typeParam;
      }
    }
  },
  productParamHandler() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has('prod')) {
      const typeParam = urlParams.get('prod');
      $('#input-product').val(typeParam);
      if ( $(window).outerWidth() > 992 ) {
        window.cstSel[1].value = typeParam;
      }
    }
  },
  getEnResourcesTranslation(){
    window.en_resources_heading = $('.en-resource-heading').val();
  },
  loadFirstResourcesFromAPI() { 
    if (window.resourcePage === 0) { 
      const that = this;
      let en;
      let url_en = $('#resources-results-first').attr('data-url') 
      let start_time = new Date().getTime();
      en = $.ajax({
        url: url_en,
        method: 'GET',
      });
      $.when(en).done(function (resources_en = '') { 
        console.log(
          url_en,
          ' Request took ',
          new Date().getTime() - start_time,
          'ms'
        );
        let resources_en_sliced = Object.fromEntries(
          Object.entries(resources_en).slice(0, 11)
        )
        window.resources = resources_en_sliced
          
        that.performResourceSearch()
        that.addEventResources()
      })
    }
  },
  loadResourcesFromAPI() {
    const that = this;
    let non_en;
    let en;

    if ( $('html')[0].lang.indexOf('en') == -1 )  {
      let url_non_en = $('#resources-results-lang').attr('data-url')
       non_en = $.ajax({
        url: url_non_en,
        method: 'GET',
      });
    }
    let url_en = $('#resources-results-en').attr('data-url') 
    let start_time = new Date().getTime();
    en = $.ajax({
      url: url_en,
      method: 'GET',
    });

    $.when(non_en,en).done(function(resources_non_en = '',resources_en = '') {
      console.log(
        url_en,
        ' Request took ',
        new Date().getTime() - start_time,
        'ms'
      );
      let resources_all_arr;
      let resources_en_arr;
      let resources_non_en_arr; 

      resources_en[0].resources[0].first = true;

      resources_en_arr = (resources_en.length != 0) ? resources_en[0].resources : [];
      resources_non_en_arr = (resources_non_en.length != 0) ? resources_non_en[0].resources : [];
      resources_all_arr = resources_non_en_arr.concat(resources_en_arr)
  
        const resources_all = {
          resources: resources_all_arr,
        }
        
      window.resources = resources_all;
      that.performResourceSearch()
      that.addEventResources()
      $('.lds-ellipsis').hide();
      $('.nav-links-resource').show();
      window.init = false;
    });
  },

  performResourceSearch() {
    const text = $('#input-search').val()
    const type = $('#input-type').val()
    const topic = $('#input-topic').val()
    const product = $('#input-product').val()

    window.foundResources = []
    window.resources.resources.forEach(function (resource) {
      let failedChecks = 0
      if (!(resource.post_title.toLowerCase().includes(text.toLowerCase()) || resource.post_content.toLowerCase().includes(text.toLowerCase()))) {
        failedChecks++
      }

      if (type != '' && resource.type != type) {
        failedChecks++
      }

      if (product != '' && resource.product != product) {
        failedChecks++
      }

      if (resource.topic == null) {
        failedChecks++
      } else if (topic != '' && resource.topic != topic){ 
        failedChecks++
      }

      if (failedChecks == 0) {
        window.foundResources.push(resource)
      }

    });
    this.renderResources();
  },

  renderResources() {
    let params = $.cookie('UTM');
    console.log(params);

    if(!params) { 
      params = '';
    } else {  
      params = '?' + params;
    }

    const that = this
    let html = '<div class="container ajax"><div class="row">'
    let foundResources = window.foundResources;
    foundResources = foundResources.slice(window.resourcePage * window.postPerPage, (window.resourcePage * window.postPerPage) + window.postPerPage)

    foundResources.forEach(function (resource) {
      // Checking for the first English resource, in order to add header
      if (resource.first === true && $('html').attr('lang') != 'en-US') {
        html += '</div><h2 class="mb-4 lg:mb-13">'+window.en_resources_heading+'</h2><div class="row">'
      }
      html += '<div class ="col-md-4 mb-14"><article class="pb-14">'
      html += '<figure>' + resource.feature_image + '</figure>'
      html += '<p>' + resource.post_title + '</p>'
      html += '<span class="cta cta-white-primary-border"><a href="' + resource.permalink+params + '" class="no-deco">' + that.getLinkLabel(resource.type) + '</a></span>'
      html += '</article></div>'
    });

    html += '</div></div>'

    let pagination = that.getPagination()
    html += pagination


    $('#resources-results-holder').html(html)
    if (window.init === false) {
      $('.nav-links-resource').show();
    }
    if (foundResources.length == 0) {
      $('#no-results').show()
    } else {
      $('#no-results').hide()
    }

    that.handlePagination()
  },

  pagination(c, m) {
  let current = c,
    last = m,
    delta = 2,
    left = current - delta,
    right = current + delta + 1,
    range = [],
    rangeWithDots = [],
    l;

  for (let i = 1; i <= last; i++) {
    if (i == 1 || i == last || i >= left && i < right) {
      range.push(i);
    }
  }

  for (let i of range) {
    if (l) {
      if (i - l === 2) {
        rangeWithDots.push(l + 1);
      } else if (i - l !== 1) {
        rangeWithDots.push('...');
      }
    }
    rangeWithDots.push(i);
    l = i;
  }

  return rangeWithDots;
  },

  getPagination() {
    let pagination = '<div class="container"><div class="nav-links-resource flex text-center mb-12">';
    const totalResources = window.foundResources.length
    // eslint-disable-next-line no-unused-vars
    let numberOfPages = Math.floor(totalResources / window.postPerPage)
    numberOfPages = (totalResources > (window.postPerPage * numberOfPages)) ? numberOfPages + 1 : numberOfPages

    numberOfPages = this.pagination(window.resourcePage, numberOfPages)
    for (let x=0; x < numberOfPages.length; x++) {
      let addclass = (parseInt(numberOfPages[x]) - 1 == window.resourcePage) ? ' color-primary' : ''
      addclass += (numberOfPages[x] == '...') ? ' no-event' : ' cursor-pointer'
      pagination += '<span class="page-number block mx-2 ' + addclass + '">' + numberOfPages[x] + '</span>'
    }

    pagination += '</div></div>'
    return pagination
  },

  handlePagination() {
    const that = this;
    $('.page-number:not(.no-event)').click(function () {
      window.resourcePage = parseInt($(this).html()) - 1
      that.renderResources()
      $([document.documentElement, document.body]).animate({
        scrollTop: $('#resources-results-holder').offset().top - 200,
      }, 700);
    })
  },

  getLinkLabel(resourceType) {
    let viewLabel = 'View';
    let readLabel = 'Read';
    let downloadLabel = 'Download';

    if (window.precisely.lang == 'fr') {
      viewLabel = 'Voir';
      readLabel = 'Lire';
      downloadLabel = 'Télécharger';
    }

    if (window.precisely.lang == 'de') {
      viewLabel = 'Siehe';
      readLabel = 'Lesen';
      downloadLabel = 'Herunterladen';
    }

    if (window.precisely.lang == 'ja') {
      viewLabel = 'ビュー';
      readLabel = '読む';
      downloadLabel = 'ダウンロード';
    }

    switch (resourceType) {
      case 'video':
      case 'webcast':
      case 'product-demo':
      case 'tool':
        return viewLabel;
      case 'ebook':
      case 'customer-story':
      case 'infographic':
        return readLabel;
      default:
        return downloadLabel;
    }
  },

  addEventResources() {
    const that = this;
    $('#resource-center-form select').change(function() {
      that.performResourceSearch()
    })
    $('#resource-center-form input').keyup(function () {
      that.performResourceSearch()
    })
  },
  handleForm() {
    const that = this;
    $('#resource-center-form input, #resource-center-form select').change(function () {
      $('#resource-center-form #paged').val(0)
      const form = $(this).parents('form')
      that.performAjaxSearch(form)
    });

    $('#resource-center-form').submit(function (e) {
      $('#resource-center-form #paged').val(0)
      const that = this;
      e.preventDefault();
      that.performAjaxSearch(this)

    });
  },
  performAjaxSearch(form) {
    console.log(form)
    /*
    const that = this;
    $.ajax({
      url: $(form).attr('action'),
      method: 'POST',
      data: $(form).serialize(),
    })
      .done(function( html ) {
        $('#resources-results-holder').html( html );
        that.navigationHandler()
        $([document.documentElement, document.body]).animate({
          scrollTop: $('#resources-results-holder').offset().top - 200,
        }, 700);
      });
     */
  },
  navigationHandler() {
    const that = this;
    $('.nav-links-resource a').click(function (e) {
      e.preventDefault();
      const page = $(this).html()
      $('#resource-center-form #paged').val(page)
      that.performAjaxSearch($('#resource-center-form'))
    });
  },
  styleSelect(){
    if ( $(window).outerWidth() > 992 ){
      window.cstSel = customSelect('.styled-select');
    }
    $('.form-group-select select').change(function(){
      console.log( $(this).parents('.form-group-select').find('.custom-select-opener span').text())
      console.log( $(this).find('option:eq(0)').text() )
      if (
          $(this).parents('.form-group-select').find('.custom-select-opener span').text() ==
          $(this).find('option:eq(0)').text()
        )
      {
        $(this).parents('.form-group-select').removeClass('active')
      } else {
        $(this).parents('.form-group-select').addClass('active')
      }

    })
  },
  // setUTMQueryParamsToAnchors() {
  //   const params = $.cookie('UTM');
  //   console.log(params);

  //   if(!params) {
  //     return;
  //   }

  //   $('#resources-results-holder a').each(function() {
  //     this.style.backgroundColor = 'red';
  //     const anchor = this;
  //     const hash = anchor.hash ? anchor.hash : anchor.href.substr(-1) === '#' ? '#' : '';

  //     if (anchor.href == 'javascript:void(0)' || hash === '#' || anchor.hostname !== window.location.hostname) {
  //       return;
  //     }

  //     if (anchor.search && window.location.search !== anchor.search) {
  //       anchor.href = anchor.origin + anchor.pathname + anchor.search + '&' + params + hash;
  //       return;
  //     }

  //     anchor.href = anchor.origin + anchor.pathname + '?' + params + hash;
  //   });
  // },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateResourceCentre.js